<template lang="pug">
  el-dialog(
    title="战表管理"
    class="el-dialog-custom"
    top="3vh"
    width="95%"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :append-to-body="true"
  )
    div.loading 正在加载...
    iframe.iframe(:src="src")
</template>

<script>
export default {
  name: 'ct-competition-iframe',
  data () {
    return {
      visible: false,
      src: ''
    }
  },
  methods: {
    init (MatchId) {
      this.visible = true
      const timestamp = new Date().getTime()
      const str = window.location.origin
      if (str.includes('dev') || str.includes('localhost') || str.includes('192.168')) {
        this.src = `https://dev.tttennis.cn/tissys/admindev/#/goLogin?MatchId=${MatchId}&time=${timestamp}`
      } else {
        this.src = `https://www.tttennis.club/tissys/admin/#/goLogin?MatchId=${MatchId}&time=${timestamp}`
        // this.src = `https://prod.tttennis.cn/tissys/admin/#/goLogin?MatchId=${MatchId}&time=${timestamp}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dialog-custom {
  overflow: hidden !important;
}

.el-dialog-custom /deep/ .el-dialog__header {
  padding: 10px;

  button {
    top: 15px;
  }
}

.el-dialog-custom /deep/ .el-dialog__body {
  height: 88vh;
  overflow: hidden;
  padding: 0;
}

.loading {
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 32px;
  color: #CDCDCD;
  font-weight: lighter;
}

.iframe {
  z-index: 9;
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
